export const middleEllipsisText = (str) => {
  if (str.length > 15) {
    return str.substr(0, 4) + "..." + str.substr(str.length - 7, str.length);
  }
  return str;
};
